import { toolkitCx } from "@sundae/ui-toolkit";
import cx from "classnames";
import { FC, memo } from "react";
import { testIds } from "../../constants/testIds.constants";

const PoolPickerSkeleton: FC = () => {
  return (
    <div
      className={cx(
        "ml-auto flex w-fit items-center justify-end gap-1 rounded-lg motion-safe:animate-pulse",
        toolkitCx.layout.spacing.both.sm,
        toolkitCx.layout.border.default,
        toolkitCx.layout.border.weight.default
      )}
      data-testid={testIds.exchangeFlow.orderControls.liquidityPoolDropdown.loader}
    >
      <div className={cx("h-4 w-20 rounded-lg", toolkitCx.layout.background.loading)} />
      <div className={cx("h-4 w-8 rounded-lg opacity-70", toolkitCx.layout.background.loading)} />
      <div className={cx("h-4 w-8 rounded-lg opacity-70", toolkitCx.layout.background.loading)} />
      <div className={cx("h-4 w-8 rounded-lg opacity-70", toolkitCx.layout.background.loading)} />
      <div className={cx("h-4 w-8 rounded-lg opacity-70", toolkitCx.layout.background.loading)} />
    </div>
  );
};

export default memo(PoolPickerSkeleton);
